export default function removeArrayDuplicates(arr: Record<string, unknown>[], key: string) {
  const map = new Map()
  arr.forEach((item) => map.set(item[key], item))
  return Array.from(map.values())
}
